import SBEditable from "../../../components/sbEditable/sbEditable"
import InnerHTMLWithScript from "../../../components/innerhtmlwithscript/innerhtmlwithscript"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import styles from "./youtubeembed.module.scss"

function YouTubeEmbed({ blok }) {
  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div className={`div-align-${blok.alignment || "left"} ${styles.youtubeembed}`} style={{maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520}}>
        <InnerHTMLWithScript id={blok._uid} text={blok.youtube} />
      </div>
    </SBEditable>
  )
}

export default YouTubeEmbed